import React from "react";
import { Link } from "react-router-dom";
import { assetImages } from "constants";
import {
  getConvertedDateText,
  getNextHourSlot,
} from "helper/EventHelper/EventHelper";

const ScheduleConfirmModal = ({
  personName,
  selectedTimeSlot,
  selectedMeetingDate,
  onModalClose,
}) => {
  return (
    <div className="request_modal">
      <div className="modal fade" id="schedule_confirm">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body p-5">
              <div className="request_alert_icon d-flex align-items-center justify-content-center">
                <img src={assetImages.checkTick} alt="" />
              </div>
              <div className="request_info text-center">
                <h3 className="text-primary fs-lg text-uppercase mb-2">
                  You are scheduled
                </h3>
                <h5 className="text-primary fs-sm mb-4">
                  A calendar invitation has been sent to your email address.
                </h5>
                <div className="meeting_bx px-3 py-4 mb-4 rounded-4 text-center">
                  <h5 className="text-primary fs-sm mb-1 fw-bold">
                    {personName}
                  </h5>
                  <h4 className="text-primary fs-xl mb-3 fw-bold">
                    60 Minute Meeting
                  </h4>
                  <h5 className="d-flex align-items-center gap-2 mb-3 justify-content-center">
                    <i className="material-icons-outlined text-pink fs-sm">
                      calendar_month
                    </i>
                    <span className="fs-sm fw-bold text-primary">
                      {selectedTimeSlot} - {getNextHourSlot(selectedTimeSlot)},{" "}
                      {getConvertedDateText(selectedMeetingDate)}
                    </span>
                  </h5>
                  <h5 className="d-flex align-items-center gap-2 justify-content-center">
                    <i className="material-icons-outlined text-pink fs-sm">
                      language
                    </i>
                    <span className="fs-sm fw-bold text-primary">
                      India Standard Time
                    </span>
                  </h5>
                </div>
                <div className="request_btns d-flex gap-2 justify-content-center">
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="btn primary-btn"
                    onClick={onModalClose}
                  >
                    Done
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleConfirmModal;
